import { ONE_STEP_AHEAD } from '../../core/preview';

export default function OneStepAheadSteps() {
  return <ol className="preview-osa-steps">
    {ONE_STEP_AHEAD.steps.map(step => <li key={step.title}><strong>{step.title}</strong><span>{step.detail}</span></li>)}
  </ol>;
}
